module.exports = __webpack_public_path__ + "img/startbiz.cc40a50e.png";